import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    organizationInvitationId: z.string(),
  }),
  response: z.void(),
};
